import { create } from 'zustand';
import { MainAnnouncementList } from 'types/MainAnnouncement';
import { BASE_URL } from 'const/ConstBase';

const state: MainAnnouncementList = {
    mainAnnouncementList: [],
};

interface Actions {
    fetchMainAnnouncement: () => void;
}

export const useMainAnnouncementStore = create<MainAnnouncementList & Actions>(
    (set) => ({
        ...state,
        fetchMainAnnouncement: () => {
            fetch(`${BASE_URL}notice/main_notice`, {
                method: 'GET',
            })
                .then(async (response) => {
                    const res = await response.json();

                    set({
                        mainAnnouncementList: res.data.notice_list,
                    });
                })
                .catch(() => {
                    console.log('fail');
                });
        },
    })
);
